import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { TokenDTO } from "../model/token-dto";
import { LoginResponseDTO } from "../model/login-response-dto";

import { Router } from '@angular/router';

export abstract class BaseService {

    LOGIN = 'login';
    env = environment;

    constructor(private readonly http: HttpClient, private readonly router: Router) {
        this.http = http
        this.router = router;
        
    }

    public saveAuthentication(loginResponse: LoginResponseDTO) {
        localStorage.setItem(this.LOGIN, JSON.stringify(loginResponse));
    }

    public isAuthenticated() {
        return localStorage.getItem(this.LOGIN) != null;
    }

    public isAdmin() {
        if(this.isAuthenticated()){
            return JSON.parse(localStorage.getItem(this.LOGIN)!).user.admin
        }
    }

    public getAuthentication(): LoginResponseDTO | null {
        const ls = localStorage.getItem(this.LOGIN);
        if (ls) {
            let login: LoginResponseDTO = JSON.parse(ls);
            return login;
        }
        return null;
    }

    public logout() {
        localStorage.removeItem(this.LOGIN);
        this.goToLogin();
    }

    goToLogin() {
        this.router.navigate(['login']);
    }

    public CreateHeaders(authenticated: boolean = true, binary: boolean = false): HttpHeaders {
        let headers = new HttpHeaders()

        if (!binary) {
            headers = headers.set('Content-Type', 'application/json')
        }

        if (authenticated) {
            let authentication = this.getAuthentication();
            if (authentication) {
                headers = headers.set('Authorization', 'Bearer ' + authentication.token.accessToken)
            }
        }
        return headers;
    }

    public GetUrl(path: string) {
        return this.env.apiUrl + path
    }

    public get<T>(path: string, parameters: HttpParams | undefined = undefined): Observable<T> {
        const headers = this.CreateHeaders()
        return this.http.get<T>(this.GetUrl(path), { headers: headers, params: parameters });
    }

    public post<T>(path: string, payload: any = undefined, parameters: HttpParams | undefined = undefined, authenticated: boolean = true): Observable<T> {
        const headers = this.CreateHeaders(authenticated)
        return this.http.post<T>(this.GetUrl(path), payload, { headers: headers, params: parameters });
    }

    public postBinary<T>(path: string, payload: any = undefined, parameters: HttpParams | undefined = undefined, authenticated: boolean = true): Observable<T> {
        const headers = this.CreateHeaders(authenticated, true)
        return this.http.post<T>(this.GetUrl(path), payload, { headers: headers, params: parameters });
    }

    public put<T>(path: string, payload: any = undefined, parameters: HttpParams | undefined = undefined): Observable<T> {
        const headers = this.CreateHeaders()
        return this.http.put<T>(this.GetUrl(path), payload, { headers: headers, params: parameters });
    }

    public delete<T>(path: string, parameters: HttpParams | undefined = undefined): Observable<T> {
        const headers = this.CreateHeaders()
        return this.http.delete<T>(this.GetUrl(path), { headers: headers, params: parameters });
    }

    refreshToken(): Promise<TokenDTO> {
        return this.apiCall(this.post<TokenDTO>("auth/refresh", this.getAuthentication()?.token, undefined, false))
    }

    apiCall<T>(request: Observable<T>, authenticated: boolean = true): Promise<T> {
        if (!this.isAuthenticated()) {
            this.logout();
        }
        return new Promise<T>((resolve, reject) => {
            request.subscribe({
                next: data => {
                    resolve(data);
                },
                error: (response: HttpErrorResponse) => {
                    if (authenticated && response.status == 401) {
                        this.refreshToken().then(response => {
                            let auth = this.getAuthentication();
                            auth!.token = response;
                            this.saveAuthentication(auth!);
                            request.subscribe({
                                next: (data: T) => {
                                    resolve(data);
                                },
                                error: (response: HttpErrorResponse) => {
                                    reject(new Error(`HTTP Error: ${response.message}`));
                                }
                            })
                        }
                        ).catch(error => {
                            this.logout();
                        }
                        );
                    } else {
                        reject(new Error(`HTTP Error: ${response.message}`))
                    }
                }
            })
        })
    }
}
